import React from 'react'

import { Dialog as MuiDialog, DialogProps } from '@material-ui/core'

const Dialog: React.FC<DialogProps> = ({ children, ...rest }) => (
  <MuiDialog {...rest}>{children}</MuiDialog>
)

export default Dialog
